const  richerHelp = {
    'cn':[
        {
            'title':`1、创业前的建议：`,
        },
        {
            'content':[`大学毕业后再创业，可满足前期对四维属性的基本需求，毕业于更好的学校会进一步提高你的四维属性。`]
        },
        {
            'title':`2、创业前期建议：`,
        },
        {
            'content':[`如果想不承担风险又得到源源不断的收入，可以尝试购买产业、升级和收购其他公司。`]
        },
        {
            'title':`3、创业中期的建议：`,
        },
        {
            'content':[`将一部分现金用来合理的安排投资和股市，高风险但是也有高回报。`]
        },
        {
            'content':[`你应该多关注活动，合理利用活动中的盈利加成、属性加成等。`]
        },
        {
            'content':[`此时应该注意你的健康值，可多前往医院提高健康值。`]
        },
        {
            'title':`4、创业后期的建议：`,
        },
        {
            'content':[`（1） 随着年龄的增长健康值的损耗也将越多，要努力提高健康值啦。`]
        },
        {
            'content':[`（2） 创业后期的现金也会越来越多，记得尝试高回报的百亿项目。`]
        },
    ],
    'en':[
        {
            'title':`1.Suggestion before starting a business:`,
        },
        {
            'content':[`Starting a business after graduating from university can easily meet the basic needs of four-dimensional attributes in the early stage, and graduating from a better school will further improve your four-dimensional attributes.`]
        },
        {
            'title':`2.Suggestions for early-stage starting a business:`,
        },
        {
            'content':[`If you want to have a steady income without taking risks, you can buy industries, upgrade and acquire other companies.`]
        },
        {
            'title':`3.Suggestions in the mid-stage of entrepreneurship:`,
        },
        {
            'content':[`The stock market represents a high risk but a high return, so why not use part of your cash to buy stocks.`]
        },
        {
            'content':[`You should pay more attention to the activity and make reasonable use of the profit bonus and attribute bonus in the event.`]
        },
        {
            'title':`4.Suggestions for the late stage of entrepreneurship:`,
        },
        {
            'content':[`a.As the age increases, you should pay attention to your health. You can go to the hospital to be healthier.`]
        },
        {
            'content':[`b.There will be more and more cash in the later stage of entrepreneurship. Remember to try high-return Valuable Projects.`]
        },
    ]
}
export { richerHelp };